import { useEffect, useState } from "react";

const useBotLink = () => {
    const [link, setLink] = useState(''
    );



    useEffect(() => {
        // Відправляємо запит на файл у папці public
        fetch(`${process.env.PUBLIC_URL}/botname.txt`)
            .then((response) => response.text())
            .then((data) => setLink(data))
            .catch((error) => console.error("Error loading text:", error));
    }, []);

    return { link };
};

export default useBotLink;
